export default "__VITE_ASSET__DbM$BtDm__"